<template>

  <span v-if="orgName"
    :style="'border-bottom: 5.28px solid ' + colour + '80'">
    <b :class="colour ? 'text-black' : 'text-black'">{{orgName}}</b>
  </span>
</template>

<script>

export default {
  name: 'OrgBadge',

  props: {

    organisation: {
      type: Object,
      default: null
    },

    name: {
      type: String,
      default: null
    },

    shortName: {
      type: String,
      default: null
    },

    color: {
      type: String,
      default: ''
    },

    logo: {
      type: String,
      default: null
    },

    noFullName: {
      type: Boolean,
      default: false
    }
  },


  watch: {
    organisation: function (org) {
      this.or = org
    },

    color: function (c) {
      this.clr = c
    }
  },


  computed: {

    orgName: function () {

      return (!this.noFullName ? (this.shortName
        ? this.shortName : this.or.shortName)
        : this.name ? this.name : this.or.name)

    },


    colour: function () {

        if (this.or && !this.clr) {
          return (this.or.colourCode ? this.or.colourCode : null)
      }

    return this.clr
    }

  },



  data () {
    return {
      or: this.organisation ? this.organisation : this.org(),
      clr: this.color
    }
  }
}

</script>
